import { translateFormatter } from '@/core/localization/translate';
import { RichTextFormatter } from '@/domains/core/localization/translate';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { B2bMulticolorDarkHorizontalLogo } from '@/domains/core/tamagoshiTailwind/logos/b2b/B2bMulticolorDarkHorizontalLogo';
export const proAdvantages = translateFormatter<{
  li: RichTextFormatter;
  strong: RichTextFormatter;
}>([{
  "type": 0,
  "value": "\n  "
}, {
  "type": 8,
  "value": "li",
  "children": [{
    "type": 8,
    "value": "strong",
    "children": [{
      "type": 0,
      "value": "Big brands at negotiated prices"
    }]
  }]
}, {
  "type": 0,
  "value": "\n  "
}, {
  "type": 8,
  "value": "li",
  "children": [{
    "type": 8,
    "value": "strong",
    "children": [{
      "type": 0,
      "value": "Professional advisors"
    }]
  }, {
    "type": 0,
    "value": " at your disposal"
  }]
}, {
  "type": 0,
  "value": "\n  "
}, {
  "type": 8,
  "value": "li",
  "children": [{
    "type": 0,
    "value": "Simplified "
  }, {
    "type": 8,
    "value": "strong",
    "children": [{
      "type": 0,
      "value": "invoice management"
    }]
  }]
}, {
  "type": 0,
  "value": "\n  "
}], undefined, undefined, "en");
function formatter(): {
  li: RichTextFormatter;
  strong: RichTextFormatter;
} {
  let i = 0;
  return {
    li: chunks => {
      const res = <Typography key={i} as="li" scale="body2">
          {chunks}
        </Typography>;
      i += 1;
      return res;
    },
    strong: (chunks: React.ReactNode[]) => {
      const res = <strong key={`strong+${i}`}>{chunks}</strong>;
      i += 1;
      return res;
    }
  };
}
export const ProAdvantages = () => <div className="flex h-full flex-col rounded-container bg-accent-secondary p-m">
    <B2bMulticolorDarkHorizontalLogo className="h-[22px]" />
    <ul className="list-outside list-disc pl-m">
      {proAdvantages.format(formatter())}
    </ul>
  </div>;